import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import "./ContextMenu.css";

const ContextMenuItem = ({ option, isPinned, isFlagged }) => {
  let name = option.name;
  let icon = option.icon;
  if (option.name === "Pin" && isPinned) {
    name = option.nameForTrueValue;
    icon = option.iconForTrueValue;
  } else if (option.name === "Flag" && isFlagged) {
    name = option.nameForTrueValue;
    icon = option.iconForTrueValue;
  }
  return (
    <>
      <div className="mr-2">{icon}</div>
      <div>{name}</div>
    </>
  );
};

function ContextMenu({
  messageId,
  anchorEl,
  open,
  handleContextClick,
  contextOptions,
  isPinned,
  isFlagged,
  createdByName,
  hasAttachment,
}) {
  let options = contextOptions;
  if (createdByName !== "You") {
    options = options.filter(({ name }) => name !== "Edit" && name !== "Delete");
  } 
  if(hasAttachment){
    options = options.filter(({ name }) => name !== "Edit" && name !== "Copy");

  }

  return (
    <>
      <Menu
        className=""
        id={`message-${messageId}`}
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleContextClick}
        PaperProps={{
          style: {
            maxHeight: 216,
            width: "20ch",
          },
        }}
      >
        {options.map((option, idx) => (
          <MenuItem
            // disabled={
            //   (createdByName !== "You" || hasAttachment) &&
            //   (option.name === "Delete" || option.name === "Edit")
            // }
            className="context-menu-items"
            key={idx}
            onClick={handleContextClick.bind(null, option.name)}
          >
            <ContextMenuItem
              option={option}
              isFlagged={isFlagged}
              isPinned={isPinned}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ContextMenu;
